import { Injectable } from '@angular/core';
import {
  DialogService,
  DialogRef,
  DialogResult
} from '@progress/kendo-angular-dialog';
import { NotificationService, Type } from '@progress/kendo-angular-notification';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VennHealthDialogService {

  constructor(
    private readonly kendoDialogService: DialogService,
    private readonly notificationService: NotificationService
  ) { }

  public showOkDialog(dialogTitle: string, dialogMessage: string, showCancelButton: boolean = false) {
    const dialog: DialogRef = this.kendoDialogService.open({
      title: dialogTitle,
      content: dialogMessage,
      actions: [
          { text: 'Ok', primary: true, themeColor: 'primary' }
      ],
      width: window.screen.width / 3,
      height: window.screen.height / 4,
      minWidth: 250
    });
  }

  public showDeleteDialog(dialogTitle: string, dialogMessage: string): Observable<DialogResult> {
    const dialog: DialogRef = this.kendoDialogService.open({
      title: dialogTitle,
      content: dialogMessage,
      actions: [
          { text: 'Cancel'},
          { text: 'Confirm Delete', primary: true, themeColor: 'primary' }
      ],
      width: 450,
      height: 200,
      minWidth: 250
    });
    return dialog.result;
  }

  public showNotification(message: string, type: Type = {style: 'success', icon: true }, hideAfter = 5000): void {
    this.notificationService.show({
      content: message,
      cssClass: 'kendo-notification-message',
      animation: { type: 'slide', duration: 400 },
      position: { horizontal: 'center', vertical: 'top' },
      type: type,
      hideAfter: hideAfter
  });
  }
}
